/**
 * QL-372 — the currencies a designer can pick when creating a portfolio
 * collection or a flow. The currency is fixed after creation.
 *
 * Names are a fixed per-language table (QL-17, no `Intl`); missing languages
 * fall back to en_GB. The server only checks the code shape (`isCurrencyCode`).
 */

import type { LocaleCode } from "./i18n";

export type CollectionCurrency = {
  /** ISO 4217 code, e.g. `NOK`. */
  code: string;
  names: { en_GB: string; nb_NO: string };
};

export const COLLECTION_CURRENCIES: readonly CollectionCurrency[] = [
  { code: "NOK", names: { en_GB: "Norwegian Krone", nb_NO: "Norske kroner" } },
  { code: "SEK", names: { en_GB: "Swedish Krona", nb_NO: "Svenske kroner" } },
  { code: "DKK", names: { en_GB: "Danish Krone", nb_NO: "Danske kroner" } },
  { code: "EUR", names: { en_GB: "Euro", nb_NO: "Euro" } },
  { code: "USD", names: { en_GB: "US Dollar", nb_NO: "Amerikanske dollar" } },
  { code: "GBP", names: { en_GB: "British Pound", nb_NO: "Britiske pund" } },
  { code: "CHF", names: { en_GB: "Swiss Franc", nb_NO: "Sveitsiske franc" } },
];

/** "NOK — Norwegian Krone"; an unknown code prints as the code alone. */
export function getCurrencyLabel(code: string, lang: LocaleCode | string): string {
  const row = COLLECTION_CURRENCIES.find((c) => c.code === code);
  if (!row) return code;
  const name = row.names[lang as keyof CollectionCurrency["names"]] ?? row.names.en_GB;
  return `${code} — ${name}`;
}
